// extracted by mini-css-extract-plugin
export default {"wrapper":"badge_wrapper__M++tA","selected":"badge_selected__9idFX"};